const breadcrumbs = {
    breadcrumbLists: document.querySelectorAll('.breadcrumbs__list-item') as NodeListOf<HTMLElement>, 
    btn: document.getElementById('jsOpenBreadcrumbs') as HTMLElement,
    init() {
        this.expandBreadcrumbs();
    },

    expandBreadcrumbs() {
        if(this.btn) {
            this.btn.addEventListener('click', () => {
                this.breadcrumbLists.forEach(item => {
                    item.classList.add('activeClass');
                });

                this.btn.classList.add('activeClass');
            })
        }
    }

}

export default breadcrumbs;
